var exports = {
  "q": "RoomOutfitModal.module__footer___cElXT0",
  "F": "RoomOutfitModal.module__shopNote___cElXT0",
};

module.exports = exports;
